<template>
  <a-dialog
      ref="dialog"
      :close-action="false"
      :dense="false"
      :loading="loading"
      :persistent="true"
      :spacer-action="false"
      :visible="visible"
      name="accept_terms_of_service"
      @close="$reset">
    <span slot="title">
      {{ $t('title') }}
    </span>
    <div slot="content">
      <p>{{ $t('content') }}<a href="https://check-position.com">https://check-position.com</a>
        {{ $t('content-company') }}</p>

      <p>{{ $t('acceptation') }}</p>

      <v-divider class="mb-4"></v-divider>

      <terms-of-service></terms-of-service>
    </div>
    <div slot="actions">
      <div class="accept-tos-checkbox">
        <v-checkbox
            v-model="accepted"
            :label="$t('label')"
            data-cy="accept-tos-checkbox"
        ></v-checkbox>
      </div>
      <div class="float-right">
        <v-btn
            :disabled="!accepted"
            color="primary"
            data-cy="accept-tos-button"
            text
            @click="submit()">
          {{ $t('actions.validate') }}
        </v-btn>
      </div>
    </div>
  </a-dialog>
</template>

<style>
.accept-tos-checkbox label {
  font-size: 14px;
}
</style>

<script>
import TermsOfService from '@/views/Common/Documents/TermsOfService'

export default {
  name: 'AcceptTermsOfServiceDialog',
  components: {TermsOfService},
  data() {
    return {
      accepted: false,
      loading: ''
    }
  },
  computed: {
    visible() {
      if (this.$account.isVerified && !this.$account.isImpersonated) {
        if (!this.$account.current.meta.cgu_accepted_at) {
          return true
        }
      }

      return false
    }
  },
  methods: {
    async submit() {
      this.loading = this.$t('update')
      try {
        await this.$account.setMeta('cgu_accepted_at', this.$moment())
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "acceptation": "Consequently, you can only access the website and the services offered if you have previously and unreservedly accepted these general conditions of use below.",
    "content": "The following provisions constitute a contract establishing the general conditions of use of the site and the Check Position services accessible through the website",
    "content-company": "edited by the company MHR Consult (SIRET 94972934700011).",
    "label": "By checking the box and clicking on the validate button, the User declares to have read and unreservedly accept the general conditions of use of the website and the services offered accessible at the address https://check-position.com",
    "title": "Acceptance of the General Conditions",
    "update": "Updating your account ..."
  },
  "es": {
    "acceptation": "En consecuencia, solo podrá acceder al sitio web y a los servicios ofrecidos si ha aceptado previa y sin reservas las presentes condiciones generales de uso a continuación.",
    "content": "Las siguientes disposiciones constituyen un contrato que establece las condiciones generales de uso del sitio y los servicios de Check Position accesibles a través del sitio web.",
    "content-company": "editado por la empresa MHR Consult (SIRET 94972934700011).",
    "label": "Al marcar la casilla y hacer clic en el botón validar, el Usuario declara haber leído y aceptar sin reservas las condiciones generales de uso del sitio web y los servicios ofrecidos accesibles en la dirección https://check-position.com",
    "title": "Aceptación de las Condiciones Generales",
    "update": "Actualizando su cuenta ..."
  },
  "fr": {
    "acceptation": "En conséquence, vous ne pouvez accéder au site Internet et aux services proposés que si vous avez accepté préalablement et sans réserve les présentes conditions générales d'utilisation ci-dessous.",
    "content": "Les dispositions qui vont suivre constituent un contrat établissant les conditions générales d’utilisation du site et des services Check Position accessibles par l’intermédiaire du site Internet ",
    "content-company": "édité par l'entreprise MHR Consult (SIRET 94972934700011).",
    "label": "En cochant la case et en cliquant sur le bouton valider, l’Utilisateur déclare avoir pris connaissance et accepter sans réserve les conditions générales d’utilisation du site Internet et des services proposés accessibles à l’adresse https://check-position.com",
    "title": "Acceptation des Conditions Générales",
    "update": "Mise à jour de votre compte ..."
  },
  "it": {
    "acceptation": "Di conseguenza, puoi accedere al sito web e ai servizi offerti solo se hai precedentemente e senza riserve accettato le presenti condizioni generali di utilizzo di seguito.",
    "content": "Le seguenti disposizioni costituiscono un contratto che stabilisce le condizioni generali di utilizzo del sito e dei servizi Check Position accessibili tramite il sito web",
    "content-company": "gestito dall'azienda MHR Consult (SIRET 94972934700011).",
    "label": "Spuntando la casella e cliccando sul pulsante valida, l'Utente dichiara di aver preso visione e accettare senza riserve le condizioni generali di utilizzo del sito web e dei servizi offerti accessibili all'indirizzo https://check-position.com",
    "title": "Accettazione delle Condizioni Generali",
    "update": "Aggiornamento del tuo account ..."
  },
  "pt": {
    "acceptation": "Consequentemente, só pode aceder ao site e aos serviços oferecidos se tiver aceite prévia e incondicionalmente estas condições gerais de utilização abaixo.",
    "content": "As disposições que se seguem constituem um contrato que estabelece as condições gerais de utilização do site e dos serviços Check Position acessíveis através do site",
    "content-company": "editado pela empresa MHR Consult (SIRET 94972934700011).",
    "label": "Ao assinalar a caixa e clicar no botão validar, o Utilizador declara ter lido e aceitar incondicionalmente as condições gerais de utilização do site e dos serviços oferecidos acessíveis no endereço https://check-position.com",
    "title": "Aceitação das Condições Gerais",
    "update": "A atualizar a sua conta ..."
  },
  "pl": {
    "acceptation": "W związku z tym możesz uzyskać dostęp do strony internetowej i oferowanych usług tylko wtedy, gdy wcześniej i bezwarunkowo zaakceptowałeś poniższe ogólne warunki użytkowania.",
    "content": "Poniższe postanowienia stanowią umowę określającą ogólne warunki użytkowania witryny i usług Check Position dostępnych za pośrednictwem strony internetowej",
    "content-company": "zarządzaną przez firmę MHR Consult (SIRET 94972934700011).",
    "label": "Zaznaczając pole i klikając przycisk zatwierdź, Użytkownik oświadcza, że zapoznał się i bezwarunkowo akceptuje ogólne warunki użytkowania strony internetowej i oferowanych usług dostępnych pod adresem https://check-position.com",
    "title": "Akceptacja Ogólnych Warunków",
    "update": "Aktualizacja Twojego konta ..."
  }
}
</i18n>
